import { AmcAnalysisTemplate, AmcAnalysisTemplateOption } from "@front/m19-api-client";
import { IDateRange } from "@front/m19-ui";
import { DateTime } from "luxon";
import { DeliveredAmcAnalysisStrategy } from "@m19-board/amc/amc-strategy-analysis-service/amc-strategy-analysis.service";
import { AmcAnalysisPeriodWindow } from "@m19-board/amc/amc-strategy-analysis-creation-page/steps/amc-analysis-period-step.component";

export interface IncompleteResults {
  days: number | null;
  firstIncompletePeriodEnds: Map<AmcAnalysisTemplate, string>;
}

export function periodWindow(strategy: DeliveredAmcAnalysisStrategy, today: DateTime): AmcAnalysisPeriodWindow {
  return {
    min: DateTime.fromISO(strategy.firstDeliveryDate, { zone: "utc" }),
    max: DateTime.min(DateTime.fromISO(strategy.lastDeliveryDate, { zone: "utc" }), today),
  };
}

export function incompleteResults(
  options: AmcAnalysisTemplateOption[],
  period: IDateRange | null | undefined,
  today: DateTime,
): IncompleteResults {
  if (!period) {
    return { days: null, firstIncompletePeriodEnds: new Map() };
  }
  const daysSinceEnd = today.diff((period.end ?? period.start).startOf("day"), "days").days;
  const incomplete = options.filter((o) => o.minDaysAfterEnd > daysSinceEnd);
  return {
    days: incomplete.length ? Math.max(...incomplete.map((o) => o.minDaysAfterEnd)) : null,
    firstIncompletePeriodEnds: new Map(
      incomplete.map((o) => [o.template, today.minus({ days: o.minDaysAfterEnd - 1 }).toISODate()!]),
    ),
  };
}
